import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

export function useVehicleDocuments() {
  const [documents, setDocuments] = useState([]);
  const [loading,   setLoading]   = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/vehicle-documents");
      setDocuments(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load documents");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  function toFormData(payload) {
    const { file, ...fields } = payload;
    const form = new FormData();
    Object.entries(fields).forEach(([key, value]) => {
      if (value !== null && value !== undefined) form.append(key, value);
    });
    if (file) form.append("file", file);
    return form;
  }

  async function addDocument(payload) {
    const { data } = await api.post("/api/vehicle-documents", toFormData(payload));
    setDocuments(prev => [...prev, data]);
    return data;
  }

  async function updateDocument(id, payload) {
    const { data } = await api.put(`/api/vehicle-documents/${id}`, toFormData(payload));
    setDocuments(prev => prev.map(d => (d.id === id ? data : d)));
    return data;
  }

  async function getFileLink(id) {
    const { data } = await api.get(`/api/vehicle-documents/${id}/file`);
    return data.url;
  }

  async function removeDocument(id) {
    await api.delete(`/api/vehicle-documents/${id}`);
    setDocuments(prev => prev.filter(d => d.id !== id));
  }

  return { documents, loading, addDocument, updateDocument, removeDocument, getFileLink, reload: load };
}
